import { Calendar, Users, TrendingUp, Clock, Shield, Award } from "lucide-react";

export function Benefits() {
    const benefits = [
        { icon: Calendar, title: "Agenda sempre cheia", desc: "Elimine os buracos da sua agenda com um fluxo constante de pacientes qualificados." },
        { icon: Users, title: "Equipe treinada", desc: "Sua recepção sabendo exatamente como converter leads em consultas agendadas." },
        { icon: TrendingUp, title: "Faturamento previsível", desc: "Previsibilidade financeira com pacientes novos todos os meses." },
        { icon: Clock, title: "Economia de tempo", desc: "Deixe a IA cuidar do primeiro atendimento enquanto você foca no que faz de melhor." },
        { icon: Shield, title: "Menos faltas", desc: "Sistema de confirmação automático que reduz drasticamente as faltas." },
        { icon: Award, title: "Autoridade digital", desc: "Construa presença online que posiciona você como referência na sua especialidade." },
    ];

    return (
        <section className="py-24 bg-slate-900 relative overflow-hidden">
            {/* Glow de fundo */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-500/10 rounded-full blur-[150px]" />

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                        Benefícios que você terá
                    </h2>
                    <p className="text-slate-400 text-lg">Resultados concretos para sua clínica</p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {benefits.map((b, i) => (
                        <div key={i} className="flex items-start gap-4 bg-slate-950/50 rounded-xl p-6 card-neon border border-brand-500/10 backdrop-blur-sm">
                            <div className="w-12 h-12 bg-brand-600/20 rounded-lg flex items-center justify-center flex-shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.3)]">
                                <b.icon className="w-6 h-6 text-brand-400" />
                            </div>
                            <div>
                                <h3 className="text-white font-bold mb-1">{b.title}</h3>
                                <p className="text-slate-400 text-sm">{b.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
